<template>
  <f7-page class="main-frmPlannedOrdersPalletizingPoint">
    <f7-navbar
      v-if="mostrarNavbarFrm"
      sliding
      no-shadow
      :style="appTheme"
    >
      <div class="lefth">
        <f7-link back>
          <img src="@/static/icons/back.svg">
        </f7-link>
      </div>
    </f7-navbar>
    <!-- Cabecera Formulario -->
    <div
      v-if="puntoPaletizadoSeleccionado != null"
      class="div-cabeceraFormulario"
    >
      <f7-row>
        <f7-col width="100">
          <span class="span-texto-gris-14-500"> {{ puntoPaletizadoSeleccionado.DescripcionCorta }} </span>
        </f7-col>
      </f7-row>
    </div>

    <div class="div-frmPedidosPlanificadosPuntoPaletizado">
      <!-- Pedidos Planificados del Punto de Paletizado -->
      <UCPreload :show="mostrarPrecarga" />

      <!-- Mensaje Información sin pedidos -->
      <span
        v-if="!mostrarPrecarga && listadoPedidosPlanificados != null && listadoPedidosPlanificados.length === 0"
        class="span-texto-azulOscuro-18-500"
      >
        {{ $t('production.palletizing.info.noPlannedOrdersInPalletizingPoint') }}
      </span>

      <!-- <div
        class="div-pedidosPlanificados"
        aria-dropeffect="none"
      >
        <div
          v-for="pedido in listadoPedidosPlanificados"
          :key="'' + pedido.IdPedidoVenta + '-' + pedido.IdLineaPedidoVenta"
          class="div-elementoTarjeta seleccionable"
          :class="{'div-elementoTarjetaSeleccionado': pedido === pedidoSeleccionado }"
          @click="SeleccionarPedido(pedido)"
        >
          <f7-row :class="{
            'row-cabeceraTarjetaSeleccionada': pedido === pedidoSeleccionado,
            'row-cabeceraTarjeta': pedido != pedidoSeleccionado,
          }">
            <f7-col
              width="60"
              style="margin-left: 10px;"
            >
              <span class="span-texto-azulOscuro-18-500 span-textoCabeceraTarjetaPedido">{{ `${pedido.Pedido} ${pedido.NombreCliente}` }}</span>
            </f7-col>
            <f7-col
              width="40"
              class="div-cabeceraTarjetaDerecha"
            >
              <span class="btn-oval-azulOscuro-26">{{ pedido.CantidadPalet }}</span>
            </f7-col>
          </f7-row>
          <f7-row class="row-pedido">
            <f7-col width="100">
              <f7-row class="row-producto">
                <f7-col width="100" />
                <span class="span-texto-azulOscuro-16-500">
                  {{ pedido.Producto.Nombre }}
                </span>
              </f7-row>

              <f7-row class="row-envase">
                <f7-col width="100" />
                <span class="span-texto-gris-14-500">
                  {{ pedido.Envase.Nombre }}
                </span>
              </f7-row>

              <f7-row class="row-paleYCamara">
                <f7-col width="100" />
                <span class="span-texto-azulOscuro-14-500">
                  {{ pedido.Pale.Nombre }}
                </span>
              </f7-row>
            </f7-col>
          </f7-row>

          <f7-row class="row-indicadoresPedido">
            <f7-col
              width="20"
              class="col-rectanguloIndicadorDePedido"
            >
              <span class="span-valorInidicadorDePedido">
                {{ pedido.NumeroEnvases }}
              </span>
              <span class="span-texto-gris-12-400">
                {{ $t('common.packages') }}
              </span>
            </f7-col>
            <f7-col
              width="20"
              class="col-rectanguloIndicadorDePedido"
            >
              <span class="span-valorInidicadorDePedido">
                {{ pedido.UnidadesPorEnvase }}
              </span>
              <span class="span-texto-gris-12-400">
                {{ $t('production.palletizing.indicators.unitsPackage') }}
              </span>
            </f7-col>
            <f7-col
              width="20"
              class="col-rectanguloIndicadorDePedido"
            >
              <span class="span-valorInidicadorDePedido">
                {{ pedido.PesoBruto * pedido.Cantidad }}
              </span>
              <span class="span-texto-gris-12-400">
                {{ $t('common.total') }}
              </span>
            </f7-col>
            <f7-col
              width="20"
              class="col-rectanguloIndicadorDePedido"
            >
              <span class="span-valorInidicadorDePedido">
                {{ pedido.PesoBruto }}
              </span>
              <span class="span-texto-gris-12-400">
                {{ $t('common.grossWeightShort') }}
              </span>
            </f7-col>
            <f7-col
              width="20"
              class="col-rectanguloIndicadorDePedido"
            >
              <span class="span-valorInidicadorDePedido">
                {{ pedido.PesoNeto }}
              </span>
              <span class="span-texto-gris-12-400">
                {{ $t('common.netWeightShort') }}
              </span>
            </f7-col>
          </f7-row>
        </div>
      </div> -->
      <div
        v-for="pedido in listadoPedidosPlanificados"
        :key="`${pedido.IdPedidoVenta}-${pedido.IdLineaPedidoVenta}`"
        class="div-pedidosPlanificados"
      >
        <UCCardGH
          :class="{ 'div-elementoTarjetaSeleccionado': pedido === pedidoSeleccionado ? true : false }"
          :object-card="pedido"
          :title="`${`${pedido.Pedido} ${pedido.NombreCliente}`}`"
          :slot-title="`${pedido.CantidadPalet}`"
          :card-title="pedido.Producto.Nombre"
          :card-sub-title="pedido.Envase.Nombre"
          :card-text="pedido.Pale.Nombre"
          :footer-type2="true"
          :array-footer="ObtenerFooter(pedido)"
          @card-selected="SeleccionarPedido(pedido)"
        />
      </div>
    </div>

    <div class="div-elementoSeparador-90 div-separador" />
    <div class="div-opcionesActions">
      <f7-row>
        <f7-col
          width="50"
          class="col-izquierdaActions"
        >
          <a
            class="link link-izquierdaActions-2"
            @click="CancelarSeleccionDePedido()"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </a>
        </f7-col>
        <f7-col
          width="50"
          class="col-derechaActions"
        >
          <a
            class="link link-derechaActions-2"
            @click="ConfirmarSeleccionDePedido()"
          >
            {{ $t('common.confirm').toUpperCase() }}
          </a>
        </f7-col>
      </f7-row>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import UCPreload from '@/components/common/UCPreload.vue';
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';
import UCCardGH from '@/components/common/UCCardGH.vue';

export default {
  name: 'FrmPlannedOrdersPalletizingPoint',
  components: {
    UCPreload,
    UCCardGH,
  },
  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    mostrarNavbarFrm: {
      type: Boolean,
      default: true,
    },
  },

  emits: [
    'cerrarFrm',
    'pedidoEstablecido',
  ],

  data() {
    return {
      puntoPaletizadoSeleccionado: null,
      lineaProduccionSeleccionada: null,
      listadoPedidosPlanificados: null, // Mantiene los pedidos asignados a las lineas.
      pedidoSeleccionado: null, // Mantiene el pedido seleccionado.
      mostrarPrecarga: false,
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDePaletizadoSeleccionado',
      'lineaDeProduccionSeleccionada',
    ]),

    ...mapWritableState(useTraceabilityStore, ['pedidoPlanificadoSeleccionado']),

    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  watch: {
    activo(val) {
      if (val != null && val !== false) {
        this.InicializarFrm();
      }
    },
  },

  methods: {
    InicializarFrm() {
      Log(this, this.InicializarFrm.name);
      this.puntoPaletizadoSeleccionado = { ...this.puntoDePaletizadoSeleccionado };
      this.lineaProduccionSeleccionada = { ...this.lineaDeProduccionSeleccionada };
      this.listadoPedidosPlanificados = null;
      this.ObtenerTodosLosPedidosPlanificadosDelPuntoDePaletizado();
    },

    SeleccionarPedido(pedido) {
      Log(this, this.SeleccionarPedido.name);
      if (this.pedidoSeleccionado === pedido) {
        this.pedidoSeleccionado = null; // Quitamos la selección.
      } else {
        this.pedidoSeleccionado = pedido;
      }
    },

    ObtenerFooter(pedido) {
      Log(this, this.ObtenerFooter.name);
      let item = [];
      item = {
        [this.$t('common.packages')]: pedido.NumeroEnvases,
        [this.$t('production.palletizing.indicators.unitsPackage')]: pedido.UnidadesPorEnvase,
        [this.$t('common.total')]: pedido.PesoBruto * pedido.Cantidad,
        [this.$t('common.grossWeightShort')]: pedido.PesoBruto,
        [this.$t('common.netWeightShort')]: pedido.PesoNeto,
      };
      return item;
    },

    CancelarSeleccionDePedido() {
      Log(this, this.CancelarSeleccionDePedido.name);
      this.pedidoPlanificadoSeleccionado = null;
      this.$emit('cerrarFrm');
    },

    ConfirmarSeleccionDePedido() {
      Log(this, this.ConfirmarSeleccionDePedido.name);
      this.pedidoPlanificadoSeleccionado = this.pedidoSeleccionado;
      this.$emit('pedidoEstablecido');
      this.$emit('cerrarFrm');
    },

    /** ************************* CONEXIONES  */
    /** ** Método ObtenerTodosLosPedidosPlanificadosDelPuntoDePaletizado */
    ObtenerTodosLosPedidosPlanificadosDelPuntoDePaletizado() {
      Log(this, this.ObtenerTodosLosPedidosPlanificadosDelPuntoDePaletizado.name);
      const self = this;
      self.mostrarPrecarga = true;
      ConexionTA.callObtenerPedidosPlanificadosLineaDeProduccion(
        this.lineaProduccionSeleccionada.Id,
      ).then((result) => {
        if (result.Valor) {
          self.listadoPedidosPlanificados = JSON.parse(result.Mensaje);
          self.mostrarPrecarga = false;
        } else {
          self.mostrarPrecarga = false;
          HiNotification.Toast(result.Mensaje);
        }
      })
        .catch(() => {
          self.mostrarPrecarga = false;
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
        });
    },
  },
};
</script>

<style lang="scss">
.main-frmPlannedOrdersPalletizingPoint {
  .div-frmPedidosPlanificadosPuntoPaletizado {
    margin: 22px;
    margin-bottom: 5px;
    margin-top: 10px;
    height: calc(100% - var(--f7-page-navbar-offset) - 22px - 36px);
    max-height: 100%;
    overflow-y: auto;
  }

  .div-separador {
    width: 94%;
    bottom: 45px;
    position: absolute;
  }

  .div-pedidosPlanificados {
    // margin: 10px;
    // max-height: 100%;
    // height: 50vh;
    // overflow-y: scroll;
  }

  .div-elementoTarjeta {
    background-color: #fff;
    color: var(--his-steel-blue);
    font-size: 15px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    margin-top: 15px;
    vertical-align: middle;
    border: 2px solid #d4d4d4;
    border-radius: 4px;
    box-shadow: 0 2px 11px 0 rgb(56 62 68 / 9%);
  }

  .div-elementoTarjeta .row-cabeceraTarjeta {
    min-height: 34px;
    background-color: #d4d4d4;
    border-radius: 4px 4px 0 0;
    align-items: center;
  }

  .div-elementoTarjeta .row-cabeceraTarjetaSeleccionada {
    min-height: 34px;
    background-color: var(--his-kiwi-pulp);
    border-radius: 4px 4px 0 0;
    align-items: center;
  }

  .div-elementoTarjetaSeleccionado {
    border: 2px solid var(--his-kiwi-pulp);
    border-radius: 4px;
  }

  .div-opcionesActions {
    width: 94%;
    bottom: 10px;
    position: absolute;
  }

  .div-cabeceraTarjetaDerecha {
    display: flex;
    justify-content: flex-end;
    align-items: -webkit-right;
  }

  .span-textoCabeceraTarjetaPedido {
    margin-left: 10px;
    margin-right: 10px;
  }

  .row-pedido {
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .row-envase {
    margin-top: 3px;
  }

  .row-paleYCamara {
    margin-top: 3px;
  }

  .row-indicadoresPedido {
    margin: 10px 10px 12px;
  }

  .row-producto {
    margin-top: 3px;
  }

  .col-rectanguloIndicadorDePedido {
    background-color: rgb(247 248 250);
    width: 55px;
    height: 60px;
    display: grid;
    padding: 12px 2px 1px;
    text-align: center;
    border-radius: 10px;
  }

  .span-valorInidicadorDePedido {
    color: var(--his-darkgray);
    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
    text-align: center;
  }

  .div-cabeceraFormulario {
    margin-top: 20px;
    margin-left: 24px;
  }

  .content-card__titlesecondary {
    min-height: 34px;
    background-color: #d4d4d4;
    color: var(--his-steel-blue);
    font-weight: 600;
    font-size: 15px;
  }
}
</style>
